import React from "react";

import { FaqCategoryItem } from "../../types";
import styles from "../FaqCategoryItems.module.scss";

const Answer = () => (
  <div className={styles.answer}>
    <div className={styles.head}>
      <span className={styles.icon}>A</span>
      <p className={styles.text}>
        学校管理画面に表示される「年度更新」の案内に沿って、年度更新作業を行ってください。
      </p>
    </div>
    <p className={styles.text}>
      マニュアルはこちら（年度更新をする）：
      <a
        className={styles.link}
        href="https://www.enageed.jp/hubfs/servicemanual/admin-features-manual.pdf?hsLang=ja"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://www.enageed.jp/hubfs/servicemanual/admin-features-manual.pdf?hsLang=ja
      </a>
    </p>
  </div>
);

export const SCHOOL_YEAR_UPDATE_FAQ: FaqCategoryItem = {
  id: "school-year-update-faq",
  question: "年度が切り替わったタイミングで対応すべきことを知りたい",
  Answer,
};
